import React from 'react';
import { Container, Typography, Box, Paper, Grid, Chip } from '@mui/material';
import { Timeline as RoadmapIcon } from '@mui/icons-material';

const StrategicRoadmap: React.FC = () => {
  const phases = [
    { phase: 'Phase 1', title: 'Foundation', quarter: 'Q4 2025', status: 'In Progress' },
    { phase: 'Phase 2', title: 'Core Components', quarter: 'Q1 2026', status: 'Planned' },
    { phase: 'Phase 3', title: 'Integration', quarter: 'Q2 2026', status: 'Planned' },
    { phase: 'Phase 4', title: 'Optimization', quarter: 'Q3 2026', status: 'Planned' },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'primary.main', mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <RoadmapIcon sx={{ fontSize: 40 }} />
          Strategic Roadmap
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Data governance implementation timeline and milestones
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {phases.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper sx={{ p: 3, height: '100%', borderTop: `4px solid ${item.status === 'In Progress' ? '#4caf50' : '#2196f3'}` }}>
              <Typography variant="overline" color="text.secondary">{item.phase}</Typography>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>{item.title}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{item.quarter}</Typography>
              <Chip label={item.status} color={item.status === 'In Progress' ? 'success' : 'primary'} size="small" />
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', border: '2px dashed #003366' }}>
        <Typography variant="h5" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
          🚧 Interactive Roadmap Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Features: Gantt charts, Milestone tracking, Dependency management, Progress visualization.
        </Typography>
      </Paper>
    </Container>
  );
};

export default StrategicRoadmap;
